import { createPlayerUI, type UIConfig, UIEvent } from "@foundation-player/ui";
import { Plugin } from "./media_plugin.js";

/**
 * For more information on how to mimic full-screen mode on iPhones,
 * see the relevant Foundation UI documentation:
 *
 * @see https://docs.player.foundation/v1/integration/foundation-ui/overview/#mimic-fullscreen-on-an-iphone
 */
export class PluginFullscreen extends Plugin {
  public isEnabled(): boolean {
    return true;
  }

  public addFoundationUiConfig(): Partial<UIConfig> {
    return {
      fullscreenEventsOnly: true,
    };
  }

  // The foundationPlayer type should be 'PlayerInterface<UIEventMap>'.
  // 'Awaited<ReturnType<typeof createPlayerUI>>' is an actual workaround because of the missing type 'UIEventMap'.
  // @see https://rtltech.atlassian.net/browse/PLAYWEBUI-1503
  public addEventListener(
    foundationPlayer: Awaited<ReturnType<typeof createPlayerUI>>,
  ): void {
    const playerWrapper: HTMLElement | null = foundationPlayer
      .getPlayerElement()
      .closest(".player-wrapper");

    if (!playerWrapper) {
      return;
    }

    foundationPlayer.addEventListener(UIEvent.EnterFullscreenRequest, () => {
      playerWrapper.classList.add("is-fullscreen");
      document.body.classList.add("u-has-fullscreen-video");
    });

    foundationPlayer.addEventListener(UIEvent.ExitFullscreenRequest, () => {
      playerWrapper.classList.remove("is-fullscreen");
      document.body.classList.remove("u-has-fullscreen-video");
    });
  }
}
